export const LOAD_DATA = 'ENDGAME_LOAD_DATA'
export const SET_REPORT_DATA = 'ENDGAME_SET_REPORT_DATA'

export const loadData = () => {
  return { type: LOAD_DATA }
}
export const setReports = (data) => {
  return { type: SET_REPORT_DATA, data: data }
}
